var map = {
	"./accelerice.png": "7247",
	"./astrapay.png": "5cd2",
	"./aws.png": "2404",
	"./best.png": "ba91",
	"./binus.png": "16cb",
	"./blibli.png": "aaeb",
	"./bri.png": "d5f9",
	"./btpns.png": "c07f",
	"./dana.png": "9c37",
	"./danamas.png": "31b6",
	"./data-academy.png": "780b",
	"./doku.png": "0866",
	"./fifgroup.png": "8a04",
	"./gojek.png": "abd2",
	"./gotoko.png": "d3f9",
	"./gtrust.png": "634f",
	"./jet-brains.png": "0ca4",
	"./kemenkes.png": "587c",
	"./microsoft.png": "b56d",
	"./nvidia.png": "bcee",
	"./prakerja.png": "8d95",
	"./red-hat.png": "0938",
	"./smartfren.png": "6aa8",
	"./telkom.png": "2665",
	"./telkomsat.png": "0c38",
	"./uic-college.png": "e413"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8695";